<ion-buttons slot="start">
    <ion-back-button mode="md"
                     text=""
                     [defaultHref]="defaultHref"
                     [icon]="icon"
                     [disabled]="disabled"
                     [class.reverse]="reverseColors"></ion-back-button>
</ion-buttons>

